export const PERFORMANCE_TYPE_CONFIG = {
  api_response_time: { color: 'red', label: 'API 에러' },
  connection_reset_retry: { color: 'orange', label: 'Connection Reset' },
  timeout: { color: 'purple', label: '타임아웃' },
  slow_query: { color: 'gold', label: '느린 쿼리' },
} as const;

export type PerformanceTypeKey = keyof typeof PERFORMANCE_TYPE_CONFIG;

export const PERFORMANCE_UI = {
  VIEWPORT_OFFSET: 920,
  LARGE_STAT_FONT_SIZE: '28px',
  MEDIUM_STAT_FONT_SIZE: '24px',
} as const;
